
export enum LanguageLevel {
    Unknown = 0,
    A1 = 10,
    A2 = 20,
    B1 = 30,
    B2 = 40,
    C1 = 50,
    C2 = 60
}
